export { default as HeroProductBlock } from './HeroProduct'
